import useTimeZoneClock from 'hooks/useTimeZoneClock';
import { getBackgroundStyle } from 'components/common/TableColor';
import moment from 'moment';
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { citySelector } from 'slices/citySlice'
import { useTranslation } from 'react-i18next';
export function toCapitalize(val) {
    return (
        <span className='text-capitalize'>
            {val}
        </span>
    )
}

const ViewTable = React.memo(({ item, isRequestView }) => {
    const { t } = useTranslation();

    console.log('item', item)

    const fields = [
        { label: t("appointmentDetail.usBasedVendor"), name: "us_based", isLocked: 0 },
        { label: t("appointmentDetail.nonUsBasedVendor"), name: "non_us_based", isLocked: 0 },
        { label: t("appointmentDetail.englishToTarget"), name: "english_to_target", isLocked: 0 },
        { label: t("appointmentDetail.spanishToTarget"), name: "spanish_to_target", isLocked: 0 },
        { label: t("appointmentDetail.courtCertified"), name: "court_certified", isLocked: 0 },
        { label: t("appointmentDetail.medicalCertified"), name: "medical_certified", isLocked: 0 },
    ];


    const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
    // const cityName = React.useMemo(() => {
    //     const cityName = cities?.find(city => city.id === item?.facility?.city_id)?.name;
    //     return cityName || "N/A";
    // }, [item?.facility?.city_id])

    const dynamicFields = React.useMemo(() => {
        const dynamic_fields = item?.appointment_details?.dynamic_fields && JSON.parse(item?.appointment_details?.dynamic_fields) || []
        const dynamicFields = dynamic_fields?.map(field => ({ name: field?.name, value: field?.value }));
        return dynamicFields || [];
    }, [item?.appointment_details?.dynamic_fields])

    const renderTableItem = (title, text,) => (
        <>
            <td className='bg-primary-secondary'>
                <h4>{title}</h4>
            </td>
            <td className='bg-primary-secondary'>{text || t("common.nA")}</td>
        </>

    )

    // const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');

    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );
    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };
    const marginTopZero = {
        marginTop: 0
    };

    // console.log('dynamicFields',dynamicFields[0].name == null)
    return (

        <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
            <div className="row_dash_1" style={rowDash1Style}>
                <div className="card_table" style={marginTopZero}>

                    <div className="Table_data_show Table_data_show1 pt-0">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.facility")} </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.facility?.facility_name || t("common.nA")}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.department")} </td>
                                    <td class="bg-primary-secondary">{item?.appointment_details?.department?.department_name || t("common.nA")}</td>
                                </tr>
                                {item?.type === 'In Person' && (
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.address")}</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.address || item.appointment_details?.facility?.street_address}</td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="interpreter p-4">
                        <h2>{t("table.vendor")}</h2>
                    </div>
                    <div className="Table_data_show Table_data_show1 pt-0">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.vendorName")} </td>
                                    <td className="bg-primary-secondary">
                                        {item?.interpreter?.vendor_type === 'agency' && (item?.agency_interpreter_name || item?.agencyInterpreter?.name)
                                            ? (item?.agency_interpreter_name || item?.agencyInterpreter?.name) + ' (' + (item?.interpreter?.first_name + ' ' + item?.interpreter?.last_name) + ')'
                                            : item?.interpreter?.vendor
                                                ? item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name
                                                : item?.interpreter?.user?.name || t("common.nA")}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.vendorEmail")} </td>
                                    <td class="bg-primary-secondary">
                                        {item?.interpreter?.vendor_type === 'agency' && (item?.agencyInterpreter?.email || item?.agency_interpreter_email)
                                            ? (item?.agencyInterpreter?.email || item?.agency_interpreter_email)
                                            : item?.interpreter?.user?.email || t("common.nA")}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.vendorPhone")} </td>
                                    <td class="bg-primary-secondary">
                                        {item?.interpreter?.vendor_type === 'agency' && (item?.agencyInterpreter?.phone || item?.agency_interpreter_phone)
                                            ? (item?.agencyInterpreter?.phone || item?.agency_interpreter_phone)
                                            : item?.interpreter?.phone || t("common.nA")}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="bg-primary-secondary">{t("appointmentDetail.checkinDate")}</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_date || t("common.nA")}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">{t("appointmentDetail.checkinTime")}</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkin_time || t("common.nA")}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">{t("appointmentDetail.checkoutDate")}</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_date || t("common.nA")}</td>

                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary">{t("appointmentDetail.checkoutTime")}</td>
                                    <td class="bg-primary-secondary" colSpan={2}>{item.appointment_assign?.checkout_time || t("common.nA")}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                </div>
                <div className="card_table" style={marginTopZero}>
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-info-secondary table" style={getBackgroundStyle(item?.status)}>
                            <tbody>
                                <tr>
                                    <td className="bg-info-secondary" style={{ ...getBackgroundStyle(item?.status), width: "40%" }}>{t("table.status")}: </td>
                                    <td className="bg-info-secondary capitalize-status" style={getBackgroundStyle(item?.status)}>{item?.status}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Patient Name: </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.patient_name  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>MRN:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.mrn_number  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>DOB:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.birth_date  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Medicaid ID:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_id  || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>Health Plan:</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.patient?.medicaid_plan  || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}


                    <div className="Table_data_show Table_data_show1 pt-0">
                        <table className="bg-primary-secondary table">
                            <tbody>
                                {fields.map((field, index) => (
                                    <tr key={index}>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>
                                            {field.label}
                                        </td>
                                        <td className="bg-primary-secondary">
                                            {item?.appointment_details?.[field.name] === 1
                                                ? t("appointmentDetail.yes")
                                                : item?.appointment_details?.[field.name] === 0
                                                    ? t("appointmentDetail.no")
                                                    : t("common.nA")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>


                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table class="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.requesterName")} </td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.requester_name || t("common.nA")}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.requesterEmail")} </td>
                                    <td class="bg-primary-secondary" toLowerCase={'text-lowercase'}>{item.appointment_details?.requester_email || t("common.nA")}</td>
                                </tr>
                                <tr>
                                    <td class="bg-primary-secondary" style={{ width: "40%" }}>{t("appointmentDetail.requesterPhone")}</td>
                                    <td class="bg-primary-secondary">{item.appointment_details?.requester_phone || t("common.nA")}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="row_dash_1" style={rowDash2Style}>
                <div className="Table_data_show Table_data_show1 pt-0 ">
                    <table class="bg-primary-secondary table">
                        <tbody>
                            <tr>
                                <td class="bg-primary-secondary" style={{ width: "20%" }}>{t("appointmentDetail.estimatedDuration")} </td>
                                <td class="bg-primary-secondary" >{item?.estimated_duration || t("common.nA")} {item?.estimated_duration_unit || t("common.nA")} </td>
                                <td class="bg-primary-secondary">{t("appointmentDetail.rescheduledReason")} </td>
                                <td class="bg-primary-secondary">{item?.appointment_details?.reschedule_reason || t("common.nA")}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary">{t("appointmentDetail.cancelReason")} </td>
                                <td class="bg-primary-secondary">{item?.appointment_details?.cancel_reason || t("common.nA")}</td>
                                <td class="bg-primary-secondary">{t("appointmentDetail.notes")}</td>
                                <td class="bg-primary-secondary">{item.appointment_assign?.notes || t("common.nA")}</td>
                            </tr>
                            <tr>
                                <td class="bg-primary-secondary">{t("appointmentDetail.dncReason")}</td>
                                <td class="bg-primary-secondary">{item?.appointment_details?.dnc_reason || t("common.nA")}</td>
                                <td class="bg-primary-secondary">{t("appointmentDetail.cncReason")}</td>
                                <td class="bg-primary-secondary">{item?.appointment_details?.cnc_reason || t("common.nA")}</td>
                            </tr>
                            {item?.appointment_details?.admin_notes &&
                            <tr>
                                <td class="bg-primary-secondary" colSpan={2}>{t("appointmentDetail.appointmentNotes")}</td>
                                <td class="bg-primary-secondary" colSpan={2}>{item?.appointment_details?.admin_notes || t("common.nA")}</td>
                            </tr>
                            }
                            {item?.status === "completed" && (
                                <>
                                <tr>
                                    <td className="bg-primary-secondary">{t("appointmentDetail.feedbackRating")}</td>
                                    <td className="bg-primary-secondary">{item.feedback?.rating ? `${item.feedback?.rating} ${t("appointmentDetail.stars")}` : t("common.nA")}</td>
                                    <td className="bg-primary-secondary">{t("appointmentDetail.feedbackComment")}</td>
                                    <td className="bg-primary-secondary">
                                        {item.feedback?.comments ?? t("common.nA")}
                                    </td>
                                </tr>
                                
                                <tr>
                                    <td className="bg-primary-secondary">{t("appointmentDetail.feedbackSuggestion")}</td>
                                    <td className="bg-primary-secondary" colSpan={3}>
                                        {item.feedback?.suggestions ?? t("common.nA")}
                                    </td>
                                </tr>
                                </>
                            )}


                        </tbody>
                    </table>
                </div>
            </div>
                  { ( dynamicFields.length > 0 && dynamicFields[0]?.name !== null)  &&    
                <div className="row_dash_1" style={rowDash2Style}>
                    <div className="Table_data_show Table_data_show1 pt-0">

                        <table className="bg-primary-secondary table">
                            {item?.id &&
                                <tbody>
                                    <tr >
                                        {dynamicFields.length > 0 && dynamicFields.map((field, index) => (
                                             renderTableItem(`${t("appointmentDetail.dynamicField")} ${index + 1}`, `${field.name}: ${field.value || t("common.nA") }`)
                                        ))}
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
                }           
          


            {item?.type !== "OPI Pre Scheduled" && item?.appointment_custom_pricing && (
                <>
                    <div className="interpreter p-4">
                        <h2>{t("appointmentDetail.customPricing")}</h2>
                    </div>

                    <div className="row_dash_1" style={rowDash2Style}>
                        <div className="Table_data_show Table_data_show1 pt-0">
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.mileage")}</td>
                                        <td className="bg-primary-secondary">{item.appointment_custom_pricing?.mileage ?? '0'}</td>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.mileageRate")}</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.mileage_rate ?? 0).toFixed(2)}
                                        </td>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.mileageTotal")}</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.mileage_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.travelHours")}</td>
                                        <td className="bg-primary-secondary">{item.appointment_custom_pricing?.travel_hours ?? '0'}</td>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.travelRate")}</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.travel_rate ?? 0).toFixed(2)}
                                        </td>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.travelTotal")}</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.travel_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.minDuration")}</td>
                                        <td className="bg-primary-secondary">{item.appointment_custom_pricing?.min_duration ?? '0'}</td>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.ratePerHour")}</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.duration_rate ?? 0).toFixed(2)}
                                        </td>
                                        <td className="bg-primary-secondary">{t("appointmentDetail.sessionTotal")}</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.session_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>{t("appointmentDetail.subtotal")}</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.sub_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>{t("appointmentDetail.discount")}</td>
                                        <td className="bg-primary-secondary">
                                            {(item.appointment_custom_pricing?.discount ?? 0) + '%'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>{t("appointmentDetail.appointmentTotal")}</td>
                                        <td className="bg-primary-secondary">
                                            ${Number(item.appointment_custom_pricing?.appointment_total ?? 0).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </>
            )}



            {/* <div className="profile-section">
                <h2>Basic Detail</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Appointment ID:" value={item?.appid} />
                    <InfoRow label="Status:" value={item?.status} />
                    <InfoRow label="Date:" value={item?.date} />
                    <InfoRow label="Time:" value={item?.start_time} />
                    <InfoRow label="Appointment Type:" value={item?.type} />
                    <InfoRow label="Language:" value={item?.language?.name} />
                    <InfoRow label="Facility:" value={item?.appointment_details?.facility?.abbreviation} />
                    <InfoRow label="Department:" value={item?.appointment_details?.department?.department_name} />
                    <InfoRow label="Estimated Duration:" value={`${item.duration} minutes`} />
                    <InfoRow label="Facility Address:" value={item.appointment_details?.facility?.address} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Client Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Client Name:" value={item?.accounts?.user?.name} />
                    <InfoRow label="Client Email:" value={item?.accounts?.user?.email} toLowerCase={'text-lowercase'} />
                    <InfoRow label="Client Phone:" value={item?.accounts?.phone} />
                </div>
            </div> */}
            {/* {(item?.interpreter || item?.vendor) &&
                <div className="profile-section">
                    <h2>Interpreter / Vendor</h2>
                    <div className='row_sec_wrapper'>
                        {item?.interpreter &&
                            <>
                                {item?.interpreter?.vendor ?
                                    <InfoRow label="Interpreter Name:" value={item?.interpreter?.user?.name + ' - ' + item?.interpreter?.vendor?.name} />
                                    :
                                    <InfoRow label="Interpreter Name:" value={item?.interpreter?.user?.name} />
                                }
                                <InfoRow label="Interpreter Email:" value={item?.interpreter?.user?.email} toLowerCase={'text-lowercase'} />
                                <InfoRow label="Interpreter Phone:" value={item?.interpreter?.phone} />
                            </>
                        }
                        {item?.vendor &&
                            <>
                                <InfoRow label="Vendor Name:" value={item?.vendor?.name} />
                                <InfoRow label="Vendor Email:" value={item?.vendor?.email} toLowerCase={'text-lowercase'} />
                            </>
                        }
                    </div>
                </div>
            } */}

            {/* <div className="profile-section">
                <h2>Patient Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Patient Name:" value={item.appointment_details?.patient?.patient_name} />
                    <InfoRow label="Patient Phone:" value={item.appointment_details?.patient_phone} />
                    <InfoRow label="Patient Birthdate:" value={item.appointment_details?.patient?.birth_date} />
                    <InfoRow label="MRN Number:" value={item.appointment_details?.patient?.mrn_number} />
                    <InfoRow label="Medicaid Id:" value={item.appointment_details?.patient?.medicaid_id} />
                    <InfoRow label="Medicaid Plan:" value={item.appointment_details?.patient?.medicaid_plan} />
                </div>
            </div> */}

            {/* <div className="profile-section">
                <h2>Requestor Information</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Requester Name:" value={item.appointment_details?.requester_name} />
                    <InfoRow label="Requester Email:" value={item.appointment_details?.requester_email} toLowerCase={'text-lowercase'} />
                    <InfoRow label="Requester Phone:" value={item.appointment_details?.requester_phone} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Appointment Detail</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Priority Level:" value={item.appointment_details?.priority_level} />
                    <InfoRow label="Provider Name:" value={item.appointment_details?.provider_name} />
                    <InfoRow label="Special Instruction:" value={item.appointment_details?.special_instruction} />
                    <InfoRow label="Encounter Source:" value={item.appointment_details?.encounter_source} />
                    <InfoRow label="Reschedule reason:" value={item?.appointment_details?.reschedule_reason} />
                    <InfoRow label="CNC reason:" value={item?.appointment_details?.cnc_reason} />
                    <InfoRow label="DNC reason:" value={item?.appointment_details?.dnc_reason} />
                    <InfoRow label="Cancel reason:" value={item?.appointment_details?.cancel_reason} />
                </div>
            </div> */}
            {/* <div className="profile-section">
                <h2>Checkin/Checkout Deatils</h2>
                <div className='row_sec_wrapper'>
                    <InfoRow label="Checkin Date:" value={item.appointment_assign?.checkin_date} />
                    <InfoRow label="Checkin Time:" value={item.appointment_assign?.checkin_time} />
                    <InfoRow label="Checkout Date:" value={item.appointment_assign?.checkout_date} />
                    <InfoRow label="Checkout Time:" value={item.appointment_assign?.checkout_time} />
                    <InfoRow label="Comments:" value={item.appointment_assign?.comments} />
                    <InfoRow label="Notes:" value={item.appointment_assign?.notes} />
                </div>
            </div> */}
        </div>
    )

})

export default ViewTable
